import React, { useState } from "react";
import CustomJS from "../../components/BuilderComponents/CustomJS";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
// import { useModalContext } from "../../context/ModalContext";
import { useModalContext } from "../../context/ModalContext";
import Input from "../../components/FormComponents/Input";
import BuilderTabs from "../../Layouts/BuilderTabs";
import Label from "../../components/FormComponents/Label";
import { generateObjectId } from "../../utils/objectIdUtils";
import { toastError } from "../../utils/toastUtils";

const ProCode = ({ allProCode, setAllProCode, tableID }) => {
  const [proCodeInput, setProCodeInput] = useState("");
  // const { getUserConfirmationForDelete } = useModalContext();
  // const [selectedProCode, setSelectedProCode] = useState(null);
  const { getUserConfirmationForDelete } = useModalContext();

  const createProCode = () => {
    if (proCodeInput.length < 3) {
      toastError("Length should be greater than 3");
      return;
    }
    const newId = generateObjectId();
    const config = {
      id: newId,
      name: proCodeInput,
      pro_script: ""
    };
    setAllProCode([...allProCode, config]);
    // setSelectedProCode(config);
    setProCodeInput("");
  };

  const deleteProcode = async (e, id) => {
    e.stopPropagation();
    const userConfirmed = await getUserConfirmationForDelete();
    if (!userConfirmed) return;
    const filterAllProCodes = allProCode.filter((procode) => procode.id !== id);
    setAllProCode(filterAllProCodes);
    // setSelectedProCode(null);
  };

  const customJsOnChange = (data, id) => {
    const copyAllProCode = JSON.parse(JSON.stringify(allProCode));
    const index = copyAllProCode.findIndex((item) => item.id === id);
    if (index !== -1) {
      copyAllProCode[index].pro_script = data;
    }
    setAllProCode(copyAllProCode);
  };

  const tabs = allProCode.map((procode) => ({
    label: procode.name,
    content: (
      <div style={{ height: "250px" }}>
        <ButtonActionIcon
          type="delete"
          style={{ position: "absolute", right: "55px" }}
          onClick={(e) => deleteProcode(e, procode.id)}
        />
        <div style={{ height: "385px", overflow: "auto" }}>
          <CustomJS
            key={procode.id}
            inputString={procode.pro_script || ""}
            tableID={tableID}
            handleChange={(data) => customJsOnChange(data, procode.id)}
            label=" "
            showFullScreenIcon={false}
          />
        </div>
      </div>
    )
  }));

  return (
    <div className="kanban_main_page">
      <div className="p_4">
        <div className="builder_form" style={{ width: "500px" }}>
          <Label>Create Pro Code</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "12px" }}>
            <Input
              placeholder="Enter pro code name"
              value={proCodeInput}
              onChange={(e) => setProCodeInput(e.target.value)}
            />
            <ButtonActionIcon type="add" onClick={createProCode} />
          </div>
        </div>
        {allProCode.length > 0 && (
          <div>
            <label className="builder_label">Available Pro Codes</label>
            <BuilderTabs tabs={tabs} tabsClass="sm_tabs" containerClass="fittabs" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProCode;
